import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { Funcionario } from 'src/app/models/funcionario';
import { CarregandoService } from 'src/app/services/carregando.service';
import { FuncionarioService } from 'src/app/services/funcionario.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';

@Component({
  selector: 'app-fila-add-operador-modal',
  templateUrl: './fila-add-operador-modal.component.html',
  styleUrls: ['./fila-add-operador-modal.component.scss']
})
export class FilaAddOperadorModalComponent implements OnInit {

  operadores: Funcionario[] = [];
  operadorSelecionado;
  operadoresCadastrados: number[] = [];
  titulo = 'Operador';

  constructor(private dialogRef: MatDialogRef<FilaAddOperadorModalComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
    private carregandoService: CarregandoService, private notificacaoService: NotificacaoService, private funcionarioService: FuncionarioService) {
    this.operadoresCadastrados = data.operadoresCadastrados;

    if (data.titulo) {
      this.titulo = data.titulo;
    }
  }

  ngOnInit() {
    this.buscarOperadores();
  }

  buscarOperadores() {
    this.carregandoService.mostra('buscarOperadores');
    this.funcionarioService.consultarFuncionarios(null, true).subscribe(funcs => {
      const funcionariosBanco: Funcionario[] = funcs;
      this.operadores = funcionariosBanco.filter(f => !this.operadoresCadastrados.includes(f.idFuncion));
      this.carregandoService.esconde('buscarOperadores');
    }, (erro) => {
      this.carregandoService.esconde('buscarOperadores');
      this.notificacaoService.erro(erro);
    });
  }

  adicionarOperador() {
    if (this.operadorSelecionado) {
      this.dialogRef.close(this.operadorSelecionado);
    }
  }

}
